import { useNavigate, useParams } from 'react-router-dom';
import { Button, Popconfirm, Spin, Tabs, Typography } from 'antd';
import { useWorkspace } from '@presentation/hooks/useWorkspaces';
import { useLeaveWorkspace } from '@presentation/hooks/useWorkspaceMembers';
import { GeneralTab } from '@presentation/components/workspace/GeneralTab';
import { MembersTab } from '@presentation/components/workspace/MembersTab';
import { paths } from '@app/routes/paths';

export const WorkspaceSettingsPage = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const navigate = useNavigate();
  const { data: workspace, isLoading } = useWorkspace(workspaceId);
  const leaveWorkspace = useLeaveWorkspace();

  if (isLoading) {
    return (
      <div className="px-6 py-10">
        <Spin />
      </div>
    );
  }

  if (!workspace) {
    return (
      <div className="px-6 py-10">
        <Typography.Text type="secondary">Workspace not found.</Typography.Text>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl px-6 py-10">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <Typography.Title level={3} className="!mb-0">
            {workspace.name}
          </Typography.Title>
          <Typography.Text type="secondary">/{workspace.slug}</Typography.Text>
        </div>
        {!workspace.abilities.delete && (
          <Popconfirm
            title="Leave this workspace?"
            onConfirm={() =>
              leaveWorkspace.mutate(workspace.id, { onSuccess: () => navigate(paths.workspaces) })
            }
            okButtonProps={{ danger: true }}
          >
            <Button danger type="text" loading={leaveWorkspace.isPending}>
              Leave workspace
            </Button>
          </Popconfirm>
        )}
      </div>

      <Tabs
        items={[
          { key: 'general', label: 'General', children: <GeneralTab workspace={workspace} /> },
          { key: 'members', label: 'Members', children: <MembersTab workspace={workspace} /> },
        ]}
      />
    </div>
  );
};
